import { motion } from "framer-motion";
import { BadgeCheck, Star } from "lucide-react";
import { useLanguage } from "../i18n";
import { SERVICES } from "../pages/services/content";

const EASE = [0.22, 1, 0.36, 1];

export default function Testimonials() {
  const { lang, t } = useLanguage();
  const ts = t.testimonials;

  return (
    <section data-testid="testimonials-section" className="bg-sand py-28 sm:py-36 lg:py-44">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-120px" }}
          transition={{ duration: 1, ease: EASE }}
          className="mx-auto max-w-2xl text-center"
        >
          <p className="kicker justify-center text-navy">
            <span className="h-px w-10 bg-sky" />
            {ts.tag}
            <span className="h-px w-10 bg-sky" />
          </p>
          <h2 className="mt-6 font-display text-4xl font-semibold leading-[1.05] tracking-tight text-navy sm:text-5xl lg:text-6xl">
            {ts.title}
          </h2>
          <p className="mt-6 text-base leading-relaxed text-mute sm:text-lg">{ts.sub}</p>
        </motion.div>

        <motion.div
          data-testid="verified-reviews-strip"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 1, delay: 0.1, ease: EASE }}
          className="mt-14"
        >
          <div className="flex flex-wrap items-center justify-center gap-3">
            <span className="flex gap-0.5" aria-label="5 su 5">
              {Array.from({ length: 5 }).map((_, i) => (
                <Star key={i} className="h-4 w-4 text-sky" fill="currentColor" strokeWidth={0} />
              ))}
            </span>
            <span className="text-sm font-extrabold text-navy">{ts.verifiedTitle}</span>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-white px-3 py-1 text-[10px] font-extrabold uppercase tracking-[0.12em] text-mute ring-1 ring-navy/10">
              <BadgeCheck className="h-3.5 w-3.5 text-med" />
              {ts.verifiedSub}
            </span>
          </div>
          <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-5">
            {SERVICES[lang].reviews.items.map((r, i) => (
              <div
                key={r.name}
                data-testid={`home-review-${i}`}
                className="flex flex-col rounded-2xl bg-white p-5 ring-1 ring-navy/10 transition-[transform,box-shadow] duration-500 hover:-translate-y-1.5 hover:shadow-[0_20px_40px_-20px_rgba(15,43,58,0.3)]"
              >
                <span className="flex gap-0.5">
                  {Array.from({ length: 5 }).map((_, sIdx) => (
                    <Star key={sIdx} className="h-3 w-3 text-sky" fill="currentColor" strokeWidth={0} />
                  ))}
                </span>
                <p className="mt-3 flex-1 text-xs leading-relaxed text-ink line-clamp-4">“{r.quote}”</p>
                <p className="mt-4 border-t border-navy/10 pt-3 text-xs">
                  <span className="font-extrabold text-navy">{r.name}</span>
                  <span className="block font-semibold text-mute">{r.from} · {r.date}</span>
                </p>
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
}
